export default "__VITE_ASSET__CXKBAX7g__"